import {HeroVideo} from "@/pages/common/Home/components/HeroVideo";

export const IntroArticle = () => {
  return (
    <div>
      <HeroVideo top={"-550"} />
    </div>
  );
};
